import { useToast } from 'primevue/usetoast';

export const useNotify = () => {
  const toast = useToast();

  const notifySuccess = (summary: string, detail?: string) => {
    toast.add({ severity: 'success', summary, detail, life: 3000 });
  };

  const notifyError = (summary: string, detail?: string) => {
    toast.add({ severity: 'error', summary, detail, life: 5000 });
  };

  return { notifySuccess, notifyError };
};
